const NS = 'ReportsCtrl';

export default function ReportsCtrl() {
  "ngInject";

  var vm = this;

  vm.title = 'Reports';
  vm.pages = [{
    name: 'Overview',
    path: 'reports.overview'
  }, {
    name: 'Booking Arrival Times',
    path: 'reports.bookingsarrivaltimes'
  }, {
    name: 'Bookings Over Time',
    path: 'reports.bookings'
  }, {
    name: 'Bookings Size',
    path: 'reports.bookingsize'
  }, {
    name: 'Bookings Errors',
    path: 'reports.bookingerrors'
  }, {
    name: 'Forecast',
    path: 'reports.forecast'
  },{
    name: 'No Show/Cancellation',
    path: 'reports.cancelledNoShowBookings'
  }
  ];
}
